import React from 'react';
import slideBaby from './swiper/slideBaby';
export default function ({ sideBarData, eleRef }) {
    // //console.log("IS user Logged IN....",eleRef.state.loggedin);
    return (
      <div>
      {eleRef.state.loggedin && !eleRef.state.isMobile &&
      <section className="slideTemp baby-slide-third-section">
          <slideBaby page={"dr-carousel-unit"} data={sideBarData} eleRef={eleRef} />
      </section>}

     

      </div>
    ) 
}
